import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import Navbar from './components/Navbar/Navbar';
import Home from './pages/Home';
import Services from './pages/Services';
// import GlobalHotspot from './components/GlobalHotspot/GlobalHotspot';
import Footer from './components/Footer/Footer';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Admin/Login'; 
import Dashboard from './pages/Admin/Dashboard'; // Import your new Dashboard component
import Projects from './pages/Admin/Projects';
import Contacts from './pages/Admin/Contact';
import LoginDetails from './pages/Admin/LoginDetails';
import Review from './pages/Review';
import AdminReview from './pages/Admin/AdminReview'; // Admin review management page
// Helper component to handle conditional Layout
const Layout = ({ children }) => {
  const location = useLocation();
  
  // Define which paths should NOT show the main Navbar/Footer/Hotspot
  // This includes the Login page and the Dashboard area
  const hideLayout = location.pathname === '/admin' || location.pathname.startsWith('/dashboard');

  return (
    <>
      {/* Show Navbar only if NOT on Admin/Dashboard pages */}
      {!hideLayout && <Navbar />} 
      
      {children}

      {/* Show Footer and Hotspot only if NOT on Admin/Dashboard pages */}
      {!hideLayout && <Footer />}
      {/* {!hideLayout && <GlobalHotspot />} */}
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            {/* PUBLIC ROUTES */}
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/review" element={<Review />} />
            
            {/* ADMIN LOGIN ROUTE */}
            <Route path="/admin" element={<Login />} />

            {/* DASHBOARD ROUTE */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/projects" element={<Projects />} />
            <Route path="/dashboard/contact" element={<Contacts />} />
            <Route path="/dashboard/login" element={<LoginDetails />} />
            <Route path="/dashboard/reviews" element={<AdminReview />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;